"use client";

/**
 * A server redirect() thrown after streaming starts is delivered as an RSC
 * error and is silently dropped when it races Clerk's post-sign-in router
 * refresh; a client replace after mount cannot be dropped.
 */
import { useEffect, useRef } from "react";
import { useRouter } from "next/navigation";

export function ClaimRedirect({ projectId }: { projectId: string }) {
  const router = useRouter();
  // Ref guards against strict-mode double-invoke and re-render re-fires.
  const redirected = useRef(false);

  useEffect(() => {
    if (redirected.current) return;
    redirected.current = true;
    router.replace(`/claim/${projectId}`);
  }, [router, projectId]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mb-4 text-lg font-medium text-foreground">
          Setting up your project...
        </div>
        <div className="text-sm text-muted-foreground">
          This will only take a moment.
        </div>
      </div>
    </div>
  );
}
